/* global s */
/* eslint-disable no-console */
'use strict';

class SearchDataPacks {
	constructor(options) {
		this.defaults = {
			minChars: 1,
			delay: 150,
			offsetLeft: 0,
			offsetTop: 1,
			cache: 0,
			menuClass: 'menu-search-data-packs',
		};

		this.fields = {
			form: document.querySelector('#form-search-data-packs'),
			searchWrapper: document.querySelector('#search-data-packs-wrapper'),
			searchFlagWrapper: document.querySelector('#search-flag-wrapper'),
			search: document.querySelector('#search-data-packs'),
		};

		this.fields = Object.assign(this.fields, options.fields);
		this.options = Object.assign(this.defaults, options.defaults);

		this.runSearch();
	}

	hasClass(el, className) {
		return el.classList ? el.classList.contains(className) : new RegExp('\\b' + className + '\\b').test(el.className);
	}

	addEvent(el, type, handler) {
		if (el.attachEvent) {
			el.attachEvent('on' + type, handler);
		} else {
			el.addEventListener(type, handler);
		}
	}

	removeEvent(el, type, handler) {
		if (el.detachEvent) {
			el.detachEvent('on' + type, handler);
		} else {
			el.removeEventListener(type, handler);
		}
	}

	/**
	 * Add an event listener to elements with a specific class name
	 * @param {String} 	elClass
	 * @param {String} 	event
	 * @param {Object} 	cb
	 * @param {Object} 	context
	 *
	 */
	addCustomEvent(elClass, event, cb, context) {
		const _this = this;
		_this.addEvent(context || document, event, function (e) {
			let found, el = e.target;
			while (el && !(found = _this.hasClass(el, elClass))) {
				el = el.parentElement;
			}
			if (found) {
				cb.call(el, e);
			}
		});
	}

	runSearch() {
		const _this = this;
		this.fields.form.addEventListener('submit', (e) => {
			e.preventDefault();
		});

		if (_this.fields.search) {
			const searchInputWrapper = _this.fields.searchWrapper;
			const searchInput = _this.fields.search;
			const searchInputFlagWrapper = _this.fields.searchFlagWrapper;

			if (searchInput.getAttribute('data-search-product')) {
				let _product = searchInput.getAttribute('data-search-product');

				if (s.options.countries_by_regions[_product]) {
					let sourceValues = [];
					const sourceCountries = s.options.countries_by_regions[_product]['local'];
					const sourceRegions = s.options.countries_by_regions[_product]['regional'];
					const sourceGlobals = s.options.countries_by_regions[_product]['global'];

					if (sourceCountries.length > 0) {
						sourceCountries.forEach((countryItem) => {
							sourceValues.push(countryItem);
						});
					}

					if (sourceRegions.length > 0) {
						sourceRegions.forEach((regionItem) => {
							sourceValues.push(regionItem);
						});
					}

					if (sourceGlobals.length > 0) {
						sourceGlobals.forEach((globalItem) => {
							sourceValues.push(globalItem);
						});
					}

					function renderNoResult(value) {
						return '<div class="search-no-result">' + value + '</div>';
					}

					function renderMatchItems(items, search) {
						const escapeSpecialChars = (str) => str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
						const highlightSearch = (str, search) => str.replace(new RegExp(`(${escapeSpecialChars(search).split(' ').join('|')})`, "gi"), '<strong>$1</strong>');

						const renderItem = (item, index) => `
							<div
								class='search-item'
								data-index='${index + 1}'
								data-name='${item.name}'
								data-flag='${item.data_country_flag ? item.data_country_flag : item.data_region_flag}'
								data-url='${item.url}'
							>
								<div class='d-flex align-items-center'>
									${renderItemFlag(item)}
									<div class='name'>${highlightSearch(item.name, search)}</div>
								</div>
								<div class='icon'>
									${s.svg('icon-arrow--x-large', '0 0 36 41', ['icon-arrow-right'], {'height': '30px'}, '', '', '')}
								</div>
							</div>
						`;

						const renderItemFlag = (item) => {
							if (item.data_country_flag) {
								return `<div class='icon-region-flag' data-flag='${item.data_country_flag}'></div>`;
							}
							if (item.data_region_flag) {
								return `<div class='icon-region-flag' data-flag='${item.data_region_flag}'><img src='${item.data_region_flag}' alt='Region flag'></div>`;
							}
							return '';
						};

						return items.map(renderItem).join('');
					}

					function suggest(matchList, searchInput) {
						const searchInputValue = searchInput.value;
						searchInput.cache[searchInputValue] = matchList;

						if (matchList.length && searchInputValue.length >= _this.defaults.minChars) {
							const itemsToRender = processMatchList(matchList, searchInput);
							searchInput.resultContainer.innerHTML = renderMatchItems(itemsToRender, searchInputValue);
						} else {
							searchInput.resultContainer.innerHTML = renderNoResult(s.options.messages.TRAVEL_ESIM_COUNTRY_NOT_SUPPORTED);
						}

						searchInput.resultContainer.style.display = 'block';
					}

					function processMatchList(matchList, searchInput) {
						const countryItemsToRender = [];
						const regionalItemsToRender = [];
						const globalItemsToRender = [];
						const destinationFlagPath = searchInput.getAttribute('data-regions-flag-path');

						matchList.forEach((matchItem) => {
							if (matchItem.hasOwnProperty('code')) {
								countryItemsToRender.push(createCountryItem(matchItem));
								if (matchItem.hasOwnProperty('regional_zones') && matchItem.regional_zones.length > 0) {
									matchItem.regional_zones.forEach((regionalZone) => {
										regionalItemsToRender.push(createRegionalItem(regionalZone, destinationFlagPath));
									});
								}
								if (matchItem.hasOwnProperty('global_operators') && matchItem.global_operators.length > 0) {
									matchItem.global_operators.forEach(() => {
										globalItemsToRender.push(createGlobalItem(destinationFlagPath));
									});
								}
							} else if (matchItem.hasOwnProperty('region')) {
								if (matchItem.region === 'regional') {
									regionalItemsToRender.push(createRegionalItem(matchItem.name, destinationFlagPath));
								}
								if (matchItem.region === 'global') {
									globalItemsToRender.push(createGlobalItem(destinationFlagPath));
								}
							}
						});

						const uniqueCountry = uniqByName(countryItemsToRender);
						const uniqueRegional = uniqByName(regionalItemsToRender);
						const uniqueGlobal = uniqByName(globalItemsToRender);

						return [...uniqueCountry, ...uniqueRegional, ...uniqueGlobal];
					}

					function createCountryItem(matchItem) {
						return {
							name: matchItem.name,
							data_country_flag: `country-${matchItem.code}`,
							data_region_flag: '',
							url: matchItem.url,
							region: 'local'
						};
					}

					function createRegionalItem(name, destinationFlagPath) {
						return {
							name: name,
							data_country_flag: '',
							data_region_flag: `${destinationFlagPath}/${name.replace(/\s+/g, '-').toLowerCase()}.png`,
							url: `${name}/regional`,
							region: 'regional'
						};
					}

					function createGlobalItem(destinationFlagPath) {
						return {
							name: s.it('TRAVEL_SIM_BUY_OPERATOR_GLOBAL'),
							data_country_flag: '',
							data_region_flag: `${destinationFlagPath}/global.png`,
							url: 'global',
							region: 'global'
						};
					}

					const uniqByName = (arr, track = new Set()) =>
						arr.filter(({name}) => (track.has(name) ? false : track.add(name)));

					function source(searchValue) {
						searchValue = searchValue.toLowerCase();
						const searchValueLength = searchValue.length;
						let matchList = [];

						// Get all matches that start with the searched letters
						sourceValues.forEach((sourceValue) => {
							const firstLettersMatch = Boolean(~sourceValue.name.substring(0, searchValueLength).toLowerCase().indexOf(searchValue));
							if (firstLettersMatch) {
								matchList.push(sourceValue);
							}
						});

						// Get all matches that have the searched letters
						sourceValues.forEach((sourceValue) => {
							const matchFound = Boolean(~sourceValue.name.toLowerCase().indexOf(searchValue));
							if (matchFound) {
								matchList.push(sourceValue);
							}
						});

						suggest(matchList, searchInput);
					}

					function onSelect(e, dataURL) {
						const destinationURL = `${searchInput.getAttribute('data-suggest-link')}/${dataURL}`;
						window.location.href = s.url(destinationURL);
					}

					// Create search result container
					searchInput.resultContainer = document.createElement('div');
					searchInput.resultContainer.className = 'search-results ' + _this.defaults.menuClass;

					searchInput.setAttribute('autocomplete', 'off');
					searchInput.cache = {};
					searchInput.lastSearchValue = '';

					_this.addCustomEvent('search-item', 'mouseleave', function () {
						const selected = searchInput.resultContainer.querySelector('.search-item.selected');
						if (selected) {
							setTimeout(function () {
								selected.className = selected.className.replace('selected', '');
							}, 20);
						}
					}, searchInput.resultContainer);

					_this.addCustomEvent('search-item', 'mouseover', function () {
						const selected = searchInput.resultContainer.querySelector('.search-item.selected');
						if (selected) {
							selected.className = selected.className.replace(' selected', '');
						}
						this.className += ' selected';
					}, searchInput.resultContainer);

					_this.addCustomEvent('search-item', 'click', function (e) {
						searchInput.value = this.getAttribute('data-name');
						showSearchFlag(this.getAttribute('data-flag'));
						onSelect(e, this.getAttribute('data-url'));
						searchInput.resultContainer.style.display = 'none';
					}, searchInput.resultContainer);

					searchInput.mousedownHandler = () => {
						const searchValue = searchInput.value;
						if (searchValue.length >= _this.defaults.minChars) {
							clearTimeout(searchInput.timer);
							if (_this.defaults.cache) {
								if (searchValue in searchInput.cache) {
									suggest(searchInput.cache[searchValue], searchInput);
									return;
								}
								for (let i = 1; i < searchValue.length - _this.defaults.minChars; i++) {
									const part = searchValue.slice(0, searchValue.length - i);
									if (part in searchInput.cache && !searchInput.cache[part].length) {
										suggest([], searchInput);
										return;
									}
								}
							}
							searchInput.timer = setTimeout(() => source(searchValue), 20);
						}
					};

					// Event handler for the focus event on the search input element
					searchInput.focusHandler = (e) => {
						// When the search input element receives focus, trigger the keyupHandler function
						searchInput.keyupHandler(e);
					};

					// Event handler for the blur event on the search input element
					searchInput.blurHandler = function () {
						let overSearchResult;
						try {
							// Check if the mouse is over the search results container
							overSearchResult = document.querySelector('.search-results:hover');
						} catch (e) {
							overSearchResult = 0;
						}
						if (!overSearchResult) {
							// If the mouse is not over the search results container, hide the search results container
							searchInput.lastSearchValue = searchInput.value;
							searchInput.resultContainer.style.display = 'none';
							setTimeout(function () {
								searchInput.resultContainer.style.display = 'none';
							}, 350); // hide suggestions on fast input
						} else if (searchInput !== document.activeElement) {
							// If the mouse is over the search results container but the search input element is not the active element,
							// set a timeout to focus the search input element
							setTimeout(function () {
								searchInput.focus();
							}, 20);
						}
					};

					searchInput.keydownHandler = function (e) {
						const key = e.key;

						// Check if the arrow keys are pressed and there are search results to navigate
						if ((key === 'ArrowDown' || key === 'ArrowUp') && searchInput.value && searchInput.resultContainer.innerHTML) {
							let next;
							let selected = searchInput.resultContainer.querySelector('.search-item.selected');

							// If no search result is selected, select the first or last result based on the arrow key pressed
							if (!selected) {
								if (key === 'ArrowDown') {
									next = searchInput.resultContainer.querySelector('.search-item');
								}
								if (key === 'ArrowUp') {
									next = searchInput.resultContainer.children[searchInput.resultContainer.children.length - 1];
								}
								if (next) {
									next.className += ' selected';
									searchInput.value = next.getAttribute('data-name');
									showSearchFlag(next.getAttribute('data-flag'));
								}
							} else {
								// If a search result is selected, select the next or previous result based on the arrow key pressed
								next = (key === 'ArrowDown') ? selected.nextElementSibling : selected.previousElementSibling;
								if (next) {
									selected.className = selected.className.replace(' selected', '');
									next.className += ' selected';
									searchInput.value = next.getAttribute('data-name');
									showSearchFlag(next.getAttribute('data-flag'));
								} else {
									// If there is no next or previous result, deselect the current result and reset the search input value
									selected.className = selected.className.replace(' selected', '');
									searchInput.value = searchInput.lastSearchValue;
									hideSearchFlag();
									next = 0;
								}
							}

							// Show the search results container and update the scroll position
							searchInput.resultContainer.style.display = 'block';
							updateScrollPosition(next);
							return false;
						} else if (key === 'Escape') {
							// If the escape key is pressed, hide the search results container and reset the search input value
							searchInput.value = searchInput.lastSearchValue;
							hideSearchFlag();
							searchInput.resultContainer.style.display = 'none';
							return false;
						} else if (key === 'Enter' || key === 'Tab') {
							// If the enter or tab key is pressed, select the currently selected search result
							searchInput.resultContainer.querySelectorAll('.search-item').forEach((element)=> {
								if (element.dataset.name && element.dataset.name.toLowerCase() == searchInput.value.toLowerCase()) {
									onSelect(e, element.getAttribute('data-url'));
									setTimeout(function () {
										searchInput.resultContainer.style.display = 'none';
									}, 20);
								}
							});

							let selectedItem = searchInput.resultContainer.querySelector('.search-item.selected');
							if (selectedItem && searchInput.resultContainer.style.display !== 'none') {
								onSelect(e, selectedItem.getAttribute('data-url'));
								setTimeout(function () {
									searchInput.resultContainer.style.display = 'none';
								}, 20);
							}
							return false;
						}
					};

					searchInput.keyupHandler = function (e) {
						const key = window.event ? e.keyCode : e.which;

						// Ignore certain keys (arrow keys, escape, and enter)
						if (!key || (key < 35 || key > 40) && key != 13 && key != 27) {
							const searchValue = searchInput.value;

							// Check if the search value has reached the minimum character length
							if (searchValue.length >= _this.defaults.minChars) {
								// Only perform a new search if the search value has changed
								if (searchValue !== searchInput.lastSearchValue) {
									searchInput.lastSearchValue = searchValue;
									clearTimeout(searchInput.timer);

									// Check if caching is enabled and if the search value is in the cache
									if (_this.defaults.cache) {
										if (searchValue in searchInput.cache) {
											// If the search value is in the cache, use the cached results
											suggest(searchInput.cache[searchValue], searchInput);
											return;
										}

										// If caching is enabled, check if any previous searches have returned empty results
										for (let i = 1; i < searchValue.length - _this.defaults.minChars; i++) {
											let part = searchValue.slice(0, searchValue.length - i);
											if (part in searchInput.cache && !searchInput.cache[part].length) {
												// If a previous search has returned empty results, return empty results for this search
												suggest([], searchInput);
												return;
											}
										}
									}

									// If the search value is not in the cache, perform a new search after a delay
									searchInput.timer = setTimeout(function () {
										source(searchValue);
									}, _this.defaults.delay);
								}
							} else {
								// If the search value is too short, hide the search results and reset the last search value
								searchInput.lastSearchValue = searchValue;
								searchInput.resultContainer.style.display = 'none';
								hideSearchFlag();
							}
						}
					};

					// Function to update the scroll position of the search results container
					function updateScrollPosition(next) {
						if (!next) {
							searchInput.resultContainer.scrollTop = 0;
						} else {
							const searchInputHeight = searchInput.resultContainer.getBoundingClientRect().height;
							const selectedTop = next.getBoundingClientRect().top - searchInput.resultContainer.getBoundingClientRect().top;
							const nextIndex = next.getAttribute('data-index');
							const nextHeight = next.getBoundingClientRect().height;
							if (selectedTop >= searchInputHeight) {
								searchInput.resultContainer.scrollTop = (nextIndex * nextHeight) - searchInputHeight;
							} else if (selectedTop < 0) {
								searchInput.resultContainer.scrollTop = selectedTop;
							}
						}
					}

					function toggleSearchFlag(dataFlag) {
						if (!searchInputFlagWrapper) return;

						const searchFlagIcon = searchInputFlagWrapper.querySelector('.icon-region-flag');
						if (!searchFlagIcon) return;

						_this.fields.searchWrapper.classList.toggle('has-icon-flag', !!dataFlag);
						searchFlagIcon.setAttribute('data-flag', dataFlag || '');

						const searchFlagIconImg = searchFlagIcon.querySelector('img');
						if (searchFlagIconImg) searchFlagIconImg.remove();

						if (dataFlag && !dataFlag.includes('country')) {
							const regionFlagImage = document.createElement('img');
							regionFlagImage.src = dataFlag;
							searchFlagIcon.appendChild(regionFlagImage);
						}
					}

					function hideSearchFlag() {
						toggleSearchFlag();
					}

					function showSearchFlag(dataFlag) {
						toggleSearchFlag(dataFlag);
					}

					_this.addEvent(searchInput, 'mousedown', searchInput.mousedownHandler);
					_this.addEvent(searchInput, 'focus', searchInput.focusHandler);
					_this.addEvent(searchInput, 'blur', searchInput.blurHandler);
					_this.addEvent(searchInput, 'keydown', searchInput.keydownHandler);
					_this.addEvent(searchInput, 'keyup', searchInput.keyupHandler);

					searchInputWrapper.appendChild(searchInput.resultContainer);
				}
			}
		}
	}
}
